import { ReactNode } from "react";
import toast from "../../module/Toast/toast.tsx";
import { usePost } from "../Fetch/useFetch.tsx";
import Modal, { ActionBar, Content } from "./Modal.tsx";
import styles from "./Modal.module.css";

const ConfirmModalBody = ({
  query,
  id,
  closeModal,
  onConfirm,
  content,
  href,
}: ConfirmModalType) => {
  const action = usePost(id ? `${query}/${id}` : `${query}`, {
    onResolve: (res) => {
      onConfirm && onConfirm(res);
      toast.success("L'action a été exécutée avec succès");
      closeModal();
    },
    onReject: async (error) => {
      toast.error(
        <>
          {"Erreur lors de l'exécution de l'action"} &nbsp;: {error.text}
        </>,
      );
      closeModal();
    },
  });
  return (
    <>
      <Content>{content ?? "Confirmer ?"}</Content>
      <ActionBar>
        <button onClick={closeModal}>Annuler</button>
        <a
          className={styles.active}
          onClick={async () => {
            // Si on a un href, on n'est pas en post
            if (href === null) {
              try {
                await action.run();
              } catch (e) {
                toast.error(
                  <>
                    {"Erreur lors de l'exécution de l'action"} &nbsp;:{" "}
                    {e.message}
                  </>,
                );
              }
            } else {
              closeModal();
            }
          }}
          href={href}
        >
          Valider
        </a>
      </ActionBar>
    </>
  );
};

const ConfirmModal = ({
  visible,
  closeModal,
  header = "Confirmation",
  query,
  id,
  onConfirm,
  content,
  href = null,
}: ConfirmModalType) => {
  return (
    <Modal {...{ visible, header, closeModal }}>
      <ConfirmModalBody
        query={query}
        id={id}
        closeModal={closeModal}
        onConfirm={onConfirm}
        content={content}
        href={href}
      />
    </Modal>
  );
};

type ConfirmModalType = {
  visible: boolean;
  header?: ReactNode | undefined;
  closeModal: () => boolean;
  onConfirm: (values: any) => void;
  id?: string | undefined;
  query: string;
  onDelete?: () => void | undefined;
  content?: string | undefined;
  href?: string | undefined;
};

export default ConfirmModal;
